import { CreatureSizeEnum, CreatureSizeNameEnum, DB_STRING_VERDAN } from '../Core';
import { getSize, getSizeId } from './accessors';
//temp hack handles specific race size for granted level size changes - need to set up logic for that
/**
 *
 * @param race
 * @param experienceInfo
 */
export function hack__deriveRaceSize(race, experienceInfo) {
    let sizeId = getSizeId(race);
    let size = getSize(race);
    if (race.baseName === DB_STRING_VERDAN && experienceInfo.currentLevel >= 5 && !race.isHomebrew) {
        sizeId = CreatureSizeEnum.MEDIUM;
        size = CreatureSizeNameEnum.MEDIUM;
    }
    return [sizeId, size];
}
